<template>
    <!--START Public Meeting-->
        <section class="section pt-5 scroll-select" id="public-meeting">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8 offset-lg-2">
                        <h1 class="section-title text-center">Public Forum - Your Proposals</h1>
                        <div class="section-title-border margin-t-20"></div>
                        <p class="section-subtitle text-muted padding-t-30 font-secondary">
                            Date: <strong>Wednesday 28th August</strong><br/>
                            Time: <strong>7pm</strong><br/>
                            Place: <strong>Friends of the Earth, Floriana</strong> (view <a href="https://www.google.com/maps/place/Friends+of+the+Earth+Malta/@35.888311,14.503162,20z/data=!4m5!3m4!1s0x0:0x6ceabe8b6b86eb65!8m2!3d35.888211!4d14.503132?hl=en-US" target="_blank">location</a>)
                        </p>
                        <p class="section-subtitle text-muted text-center padding-t-30 font-secondary">
                            “Il-Proposti Tiegħek” (Your Proposals) is a public forum (view Facebook <a href="https://www.facebook.com/events/829595174108782" target="_blank">event</a>) that aims to open up a space for citizens to give their proposals and input on a number of issues, especially those related to the six demands of the Iż-Żejjed Kollu Żejjed (Enough is Enough) protest of the 7th September
                        </p>
                        <p class="section-subtitle text-muted text-center padding-t-30 font-secondary">
                            We’re interested in hearing your views regarding these demands, and to this effect, we are holding this Public Forum at Friends of the Earth (in Floriana, close to the Planning Authority) at 7pm. We will be noting down your proposals which we will integrate in a set of reasonable demands, which we will present to the authorities after the protest of the 7th September.
                        </p>
                        <p class="section-subtitle text-muted text-center padding-t-30 font-secondary">
                            The discussion will be held in Maltese (translators are welcome). In the meantime, those who would like more information can send a message to the event page.
                        </p>
                        <p class="section-subtitle text-muted text-center padding-t-30 font-secondary">
                            This event is strictly reserved to those who have no means of making their voices heard during five years of legislature; Members of Parliament are not welcome.
                        </p>
                    </div>
                </div>
            </div>
        </section>
        <!--START SERVICES-->
</template>

<script>
"use strict";
export default {
  name: 'PublicMeeting'
}
</script>
